/** Links the menu button to the sheet it controls, via aria-controls. */
export const MOBILE_MENU_ID = 'mobile-menu';
